module.exports = __webpack_public_path__ + "static/img/tccMerchant.57f4484d.png";